import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router'

import { addNotification } from 'store/slices/notifications'
import { useUpdateGroupMutation } from 'store/api/yay/group'
import { endpoints } from 'store/api/yay/group'
import { useNavigate } from 'features/i18n/router'

import GroupSettingsForm from 'features/GroupSettings/GroupSettingsForm'

const GroupSettingsModal = (props: { groupId: string }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const location = useLocation()
  const [updateGroup] = useUpdateGroupMutation()

  const groupRes = endpoints?.getGroup?.useQueryState?.({
    groupId: props?.groupId?.toString?.(),
  })

  // To let `<select />` bind its value properly.
  if (groupRes?.isLoading) {
    return null
  }

  return (
    <GroupSettingsForm
      group={groupRes?.data}
      onSubmit={(data) => {
        return updateGroup({
          ...data,
          id: +props?.groupId,
        }).then((res) => {
          if (res?.['data']?.status == 'success') {
            dispatch(
              addNotification({
                message: t('common.success'),
              })
            )

            navigate(location.pathname)
          }
        })
      }}
    />
  )
}

export default GroupSettingsModal
